// extracted by mini-css-extract-plugin
export default {"green":"#73c06b","sticky":"BasicHeader_sticky__e3QhX","headerStyling":"BasicHeader_headerStyling__WbPA8","containDemo":"BasicHeader_containDemo__HjTF2"};